import IndexPage from 'flarum/forum/components/IndexPage';
import Page from 'flarum/common/components/Page';
import ItemList from 'flarum/common/utils/ItemList';
import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';

export default class CertificationLookupPage extends IndexPage {
  oninit(vnode) {
    Page.prototype.oninit.call(this, vnode);
    this.bodyClass = 'App--index';
    this.code = '';
    this.result = null;
    this.loading = false;
    this.error = null;
  }

  hero() {
    const hidden = app.forum.attribute('taroExamHeroHidden') || false;
    if (hidden) return null;
    const subtitle = app.forum.attribute('taroExamHeroSubtitle') || '输入认证码验证持证人认证信息';
    const icon = app.forum.attribute('taroExamHeroIcon') || 'fas fa-certificate';
    const color = app.forum.attribute('taroExamHeroColor') || '';
    return (
      <header className="Hero" style={color ? { '--hero-bg': color } : undefined}>
        <div className="container">
          <h1 className="Hero-title">
            <i className={icon} style={{ marginRight: '8px' }} />
            认证查询
          </h1>
          {subtitle ? <div className="Hero-subtitle">{subtitle}</div> : null}
        </div>
      </header>
    );
  }

  contentItems() {
    const items = new ItemList();
    items.add('lookupContent', this.lookupContent(), 100);
    return items;
  }

  async lookup() {
    const code = this.code.trim();
    if (!code) return;
    this.loading = true;
    this.error = null;
    this.result = null;
    m.redraw();

    try {
      const res = await app.request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + '/taro/certifications/query/' + encodeURIComponent(code),
      });
      this.result = res.data.attributes;
    } catch (e) {
      this.error = '认证码无效或已过期';
    } finally {
      this.loading = false;
      m.redraw();
    }
  }

  lookupContent() {
    return (
      <div className="CertificationLookupPage">
        <h2 className="CertLookup-title">认证查询</h2>
        <p className="CertLookup-desc">输入认证码验证持证人认证信息</p>

        <div className="CertLookup-form">
          <input
            className="FormControl CertLookup-input"
            type="text"
            placeholder="请输入认证码，如 TARO-XXXXXXXX"
            value={this.code}
            oninput={(e) => { this.code = e.target.value; m.redraw(); }}
            onkeydown={(e) => { if (e.key === 'Enter') this.lookup(); }}
          />
          <Button className="Button Button--primary" loading={this.loading} onclick={() => this.lookup()}>
            查询
          </Button>
        </div>

        {this.error && (
          <div className="CertLookup-error">
            <i className="fas fa-exclamation-circle" /> {this.error}
          </div>
        )}

        {this.result && (
          <div className="CertLookup-result">
            <h3><i className="fas fa-certificate" /> 认证信息</h3>
            <div className="CertLookup-resultRow">
              <span className="CertLookup-label">认证等级</span>
              <span className={'CertificationBadge CertificationBadge--' + this.result.level}>
                <i className="fas fa-certificate" /> {this.result.level}
              </span>
            </div>
            <div className="CertLookup-resultRow">
              <span className="CertLookup-label">认证码</span>
              <code>{this.result.code}</code>
            </div>
            <div className="CertLookup-resultRow">
              <span className="CertLookup-label">有效期至</span>
              <span>{this.result.expires_at || '永久'}</span>
            </div>
            <div className="CertLookup-resultRow">
              <span className="CertLookup-label">状态</span>
              <span className={this.result.is_active ? 'CertLookup-active' : 'CertLookup-inactive'}>
                {this.result.is_active ? '✅ 有效' : '❌ 已失效'}
              </span>
            </div>
          </div>
        )}
      </div>
    );
  }
}
